/* Reuse the live product resolver and dialog; never infer charts from card images. */
(() => {
  const drawer = document.querySelector('#CartDrawer.cro-cart-visual');
  const script = document.querySelector('script[data-cro-cart-charts]');
  if (!drawer || !script || !('fetch' in window)) return;
  const cache = new Map();
  const pending = new WeakMap();
  const handles = new WeakMap();
  let queued = false;
  let suppressDrawerEscapeUntil = 0;
  // Native dialog lives under body; prevent the theme's outside-click/Escape
  // handlers from treating a chart interaction as a request to close the cart.
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && Date.now() < suppressDrawerEscapeUntil) event.stopPropagation();
  }, true);

  function chartFor(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
    url.searchParams.set('section_id', 'cro-cart-size-chart');
    url.searchParams.set('preview_theme_id', script.dataset.themeId);
    const signal = typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(8000) : undefined;
    const request = fetch(url.toString(), {credentials:'same-origin', signal})
      .then(response => { if (!response.ok) throw new Error('Chart unavailable'); return response.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const component = doc.querySelector('sleefs-size-chart');
        return component?.querySelector('[data-size-chart-open]') ? component.outerHTML : null;
      }).catch(() => { cache.delete(handle); return null; });
    cache.set(handle, request);
    return request;
  }
  function refresh() {
    if (!drawer.classList.contains('drawer--is-open')) return;
    drawer.querySelectorAll('[data-cro-recommendations-slot] .lb-flat-card-host[lb-product-handle]').forEach(card => {
      const handle = card.getAttribute('lb-product-handle');
      if (!/^[a-zA-Z0-9][a-zA-Z0-9-]{0,200}$/.test(handle || '')) return;
      const target = card.querySelector('.lb-cta-actions');
      if (!target) return;
      const existing = card.querySelector('[data-cro-offer-chart]');
      if (existing && existing.dataset.croOfferChart !== handle) existing.remove();
      if (card.querySelector('[data-cro-offer-chart]') || pending.get(card) === handle || handles.get(card) === handle) return;
      pending.set(card, handle);
      chartFor(handle).then(html => {
        if (pending.get(card) !== handle) return;
        pending.delete(card);
        if (!card.isConnected || card.getAttribute('lb-product-handle') !== handle) return;
        if (!html) { handles.set(card, handle); return; }
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('sleefs-size-chart');
        if (!source) return;
        const component = document.importNode(source, true);
        component.dataset.croOfferChart = handle;
        const dialog = component.querySelector('dialog');
        dialog?.addEventListener('click', event => event.stopPropagation());
        dialog?.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            suppressDrawerEscapeUntil = Date.now() + 500;
            event.stopPropagation();
          }
        });
        dialog?.addEventListener('cancel', () => { suppressDrawerEscapeUntil = Date.now() + 500; });
        target.insertBefore(component, target.querySelector('lb-button')); 
      });
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }
  const observer = new MutationObserver(schedule);
  observer.observe(drawer, {childList:true,subtree:true,attributes:true,attributeFilter:['class','lb-product-handle']});
  schedule();
})();
